import { Sprout } from "lucide-react";

/**
 * "What not to panic about" — a calming counter-balance section.
 *
 * Renders only when stored data exists. No AI calls.
 */
export default function ReportWhatNotToPanic({ items }) {
    if (!Array.isArray(items) || items.length === 0) return null;
    return (
        <section
            className="bl-card p-6 md:p-8 bg-bl-teal-tint/30 border-bl-primary/20"
            data-testid="report-what-not-to-panic"
        >
            <div className="bl-eyebrow text-bl-primary">
                <Sprout className="w-3.5 h-3.5" /> Calm context
            </div>
            <h2 className="mt-3 font-display font-semibold text-2xl text-bl">
                What not to panic about.
            </h2>
            <p className="mt-2 text-bl-muted leading-relaxed max-w-2xl">
                A few findings that typically don't demand immediate
                negotiation pressure — useful context so you focus on what
                actually moves the deal.
            </p>
            <ul className="mt-5 space-y-3">
                {items.map((it, i) => (
                    <li
                        key={i}
                        className="flex flex-col gap-1 pb-3 border-b border-bl last:border-0 last:pb-0"
                        data-testid={`report-not-panic-item-${i}`}
                    >
                        <div className="flex flex-wrap items-baseline gap-2">
                            <span className="font-display font-semibold text-bl">
                                {it.title}
                            </span>
                            {it.category && (
                                <span className="text-[10px] tracking-[0.18em] uppercase text-bl-muted">
                                    · {it.category}
                                </span>
                            )}
                        </div>
                        <p className="text-sm text-bl-muted leading-relaxed">
                            {it.explanation || it.note}
                        </p>
                    </li>
                ))}
            </ul>
            <p className="mt-5 text-xs text-bl-muted leading-relaxed">
                Important: this section never overrides safety, structural, or
                moisture concerns. Always cross-reference your inspector's
                recommendations.
            </p>
        </section>
    );
}
